import {wonlexCareProfile} from '../../../shared/wonlex-profile.js';
import {wonlexFeatureCopy} from '../../../shared/wonlex-ui.js';
import {useBrowserPageQuery} from '../../useBrowserNavigation';
import {TimeZonePanel} from '../components/TimeZonePanel';
import {zonedDateKey as displayDateKey} from '../../../shared/display-timezone.js';
import {displayTimeZone} from '../../../shared/display-timezone.js';
import {shiftDateRange} from '../../../shared/date-range-selection.js';
import {customerDeviceIdentity,qualityBatteryLabel} from '../../../shared/customer-review-display.js';
import {ModelIcon} from '../../ModelIcon';
import {productDeviceName} from '../../../shared/model-products.js';
import {TimePolicyPanel,MeasurementAlertPanel} from '../components/CareSettings';
import {VoiceMessagesPanel} from '../components/VoiceMessages';
import {PhonebookPanel} from '../components/Phonebook';
import {useRouteAnimation} from '../../useRouteAnimation';
import {RouteTimeline} from '../../RouteTimeline';
import {DevicePhotoEditor} from '../components/WearerPhoto';
import {HealthHistory} from '../components/HealthHistory';
import {ButtonRow} from '../../ButtonLayout';
import {estimatedRouteConnection} from '../../route-model';
import {routePlaybackStep,routePlaybackIdentity} from '../../../shared/route-playback.js';
import Constants from "expo-constants";
import { CalendarPicker } from "../components/CalendarPicker";
import { EventHistoryScreen } from "./EventHistoryScreen";
import { MeasurementFlow } from "../components/measurement/MeasurementFlow";
import { NamedZonesScreen } from "./NamedZonesScreen";
import { HelpPanel } from "../../HelpPanel";
import {AppearanceControls} from '../../AppearanceControls';
import {useLayout} from '../../LayoutContext';
import { FeatureSupportNote } from "../../FeatureSupportNote";
import { featureSupport } from "../../../shared/feature-support.js";
import { PhoneNotificationPanel } from "../../PhoneNotifications";
import { BatteryAlertsPanel } from '../../BatteryAlertsPanel';
import { AlertRecipientsPanel } from '../../AlertRecipientsPanel';
import { hardwareParameters } from "../../../shared/hardware-settings.js";
import {RouteRangePicker} from '../../RouteRangePicker';
import {routeRange} from '../../../shared/route-range.js';
import React, { useEffect, useMemo, useState } from "react";
import { AppState, Platform, Pressable, View } from "react-native";
import { Text, useCopy } from "../copy";
import { useLive } from "../live";
import { useTokens } from "../theme/tokens";
import { Icon } from "../components/Icon";
import { MapSlot } from "../components/MapSlot";
import {
  Button,
  Card,
  Field,
  Metric,
  Pill,
  Row,
  Screen,
  SectionTitle,
  Segmented,
  StatePanel,
  SwitchRow,
  Title,
} from "../components/primitives";
import { getFeature } from "../domain/featureCatalog";
import { ActivityScreen } from "./ActivityScreen";
import { HardwarePanel } from "../../HardwarePanel";
import {
  FallAlarmSettingsPanel,
  HardwareSettingsPanel,
  HardwareSettingCard,
} from "../../HardwareSettingsPanel";
import { TrackerArchivePanel } from "../../TrackerArchivePanel";
import { TrackerCallPanel } from "../../TrackerCallPanel";
import { ActivityProfileModal } from "../../ActivityProfileModal";
import { AccountPasswordModal } from "../../AccountPasswordModal";
import { TrackerPasswordModal } from "../../TrackerPasswordModal";
import {
  dateKey,
  activityDayBounds,
  validDateKey,
  shiftDate,
  validActivityProfile,
} from "../../../shared/activity-model.js";
import {
  prettyDate,
  UPLOAD_INTERVALS,
  TELEMETRY_WINDOWS,
  intervalLabel,
  validUploadInterval,
  uploadRequestState,
} from "../../../shared/product-settings.js";
import { estimateWalkingActivity } from "../../activity-estimates";
import {
  hardwareWaitSeconds,
  type HardwareCommandType,
} from "../../hardware-types";
import { findWaitSeconds, uploadWaitSeconds } from "../../tracker-view";
import { translate } from "../../../i18n/catalogues.js";
import { Info,StepSlider } from "../../ProductControls";
import {modelName} from '../../../shared/model-products.js';
import {petProfile} from '../../../shared/pet-profile.js';
import {featureAvailable,hasAlarmTab} from '../../../shared/device-profile.js';
import { validZone } from "../../../shared/gps-zone.js";
import type { LocalRoutePoint } from "../../local-api";
const EMPTY: LocalRoutePoint[] = [];
function Page({
  title,
  subtitle,
  children,
  testID,
}: {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  children: React.ReactNode;
  testID?: string;
}) {
  const {actions}=useLive();
  return (
    <Screen testID={testID}>
      <Title onBack={actions.goBack} subtitle={subtitle}>{title}</Title>
      {children}
    </Screen>
  );
}
function useNow() {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  return now;
}
export function FlowRouter({ screenId }: { screenId: string }) {
  const {state,locale}=useLive();
  if(!featureAvailable(state.snapshot?.device,screenId))return <Page title={locale==='da-DK'?'Funktionen findes ikke på denne enhed':'Feature unavailable for this device'}><StatePanel state='unsupported' title={locale==='da-DK'?'Vælg en anden enhed':'Choose another device'}/></Page>;
  const configurationScreens=['position-gps-zone','position-wifi-zone','position-frequency','care-measure','care-medicine','care-schedules','care-callback','device-find','device-power','device-sos','device-sms','device-wrist','device-fall','device-sound','device-clock','device-safe-mode','device-language-time','care-message'];
  if(state.snapshot?.device?.access?.canConfigure===false&&configurationScreens.includes(screenId))return <Page title={getFeature(screenId)?.title??(locale==='da-DK'?'Armbåndets indstillinger':'Bracelet settings')}><StatePanel state="unsupported" title={locale==='da-DK'?'Adgang til visning':'View access'} message={translate(locale,'settings.permission')}/></Page>;
  if (screenId === "events-notifications")
    return (
      <Page title="Telefonnotifikationer">
        <PhoneNotificationPanel showTitle={false} />
        {!hasAlarmTab(state.snapshot?.device)&&<BatteryAlertsPanel />}
        <AlertRecipientsPanel />
      </Page>
    );
  if (screenId === "events-archive") return <EventHistoryScreen />;
  if (screenId === "position-route") return <Route />;
  if (screenId === "position-live") return <LivePosition />;
  if (screenId === "position-gps-zone") return <Zone />;
  if (screenId === "care-measure") return <Measure />;
  if (screenId === "care-medicine") return <Medicine />;
  if (screenId.startsWith("event:"))
    return <EventDetail id={screenId.slice(6)} />;
  if (screenId === "activity-analysis" || screenId === "activity-records")
    return (
      <ActivityScreen analysis recordsOnly={screenId === "activity-records"} />
    );
  if (screenId === "device-find") return <Find />;
  if (screenId === "device-power") return <Power />;
  return <Detail id={screenId} />;
}
function LivePosition() {
  const { tracker, actions } = useLive();
  return (
    <Page
      title="Aktuel placering"
      subtitle="Telefonens egen placering vises ikke som armbåndets"
      eyebrow={tracker.entity.trackerName}
    >
      <MapSlot
        label={tracker.positionAge}
        onRefresh={() => void actions.refreshPosition()}
        onOpenExternal={actions.openExternalMap}
      />
      <Card>
        <Row
          title="Registreret"
          value={tracker.positionAge ?? "Ukendt"}
          icon="clock"
        />
        <Row
          title="Kilde"
          value={tracker.positionAge ? "GPS" : "Ukendt"}
          icon="gps"
        />
        <Row title="Nøjagtighed" value="Ikke rapporteret" icon="radius" />
      </Card>
    </Page>
  );
}
function Route() {
  const { state, session, locale, routeDate, actions, onActivityDay } =
      useLive(),
    { spacing, colors, design, radius, type } = useTokens(),
    copy = useCopy();
  const [urlQuery,setUrlQuery]=useBrowserPageQuery(state.accountEmail);
  const [date, setDate] = useState(urlQuery.start??routeDate ?? displayDateKey()),
    [draft, setDraft] = useState(date),
    [edit, setEdit] = useState(false),
    [playing, setPlaying] = useState(false),
    [cursor, setCursor] = useState<number | undefined>(),
    [speed, setSpeed] = useState("1"),
    [restart, setRestart] = useState(0);
  const [endDate,setEndDate]=useState(urlQuery.end??date);
  const gt06=state.snapshot?.device?.profile?.protocol==='gt06';
  const clockConfirmed=gt06&&state.snapshot?.device?.profile?.timeZoneConfirmed===true;
  const [archive,setArchive]=useState(urlQuery.basis==='receipt');
  useEffect(()=>{if(Platform.OS!=='web')return;setDate(urlQuery.start??routeDate??displayDateKey());setEndDate(urlQuery.end??urlQuery.start??routeDate??displayDateKey());setArchive(urlQuery.basis==='receipt');setPlaying(false);setCursor(undefined);},[urlQuery.start,urlQuery.end,urlQuery.basis]);
  const timeBasis=clockConfirmed&&!archive?'measured':'receipt';
  const receiptArchive=gt06&&timeBasis==='receipt';
  const bounds = useMemo(() => routeRange(date,endDate,displayTimeZone())!, [date,endDate,displayTimeZone()]),
    route =
      state.routeHistory && state.routeHistory.startAt === bounds.startAt &&
      state.routeHistory.endAt === bounds.endAt && (state.routeHistory.timeBasis??'receipt')===timeBasis
        ? state.routeHistory
        : null,
    points = useMemo(()=>route?.points.map(p=>timeBasis==='measured'?{...p,receivedAt:p.measuredAt??p.receivedAt}:p)??EMPTY,[route,timeBasis]),
    index = cursor !== undefined && cursor >= 0 && cursor < points.length ? cursor : undefined;
  const estimatedCurrent = index !== undefined && index > 0 && Boolean(estimatedRouteConnection(points[index-1], points[index]));
  const profile = state.snapshot?.device?.activityProfile,
    estimate = useMemo(
      () =>
        estimateWalkingActivity(
          points,
          profile?.strideCm ?? NaN,
          profile?.weightKg ?? NaN,
        ),
      [points, profile],
    );
  useEffect(() => {
    if (
      !state.networkUnavailable &&
      state.snapshot?.device?.capabilities?.routeHistory
    )
      void session.loadRoute(bounds.startAt, bounds.endAt,false,timeBasis);
    return () => session.cancelRoute();
  }, [
    bounds.startAt,
    bounds.endAt,
    timeBasis,
    session,
    state.snapshot?.device?.id,
    state.snapshot?.device?.capabilities?.routeHistory,
    state.networkUnavailable,
  ]);
  const playbackIdentity=routePlaybackIdentity(state.snapshot?.device?.id,route)+timeBasis;
  useEffect(() => {
    setPlaying(false);
    setCursor(undefined);
  }, [playbackIdentity]);
  useEffect(() => {
    const sub = AppState.addEventListener("change", (s) => {
      if (s !== "active") setPlaying(false);
    });
    return () => sub.remove();
  }, []);
  const playback=routePlaybackStep(points,index,Number(speed));
  const playbackFraction=useRouteAnimation(index,playing,playback?.delayMs,()=>{if(playback)setCursor(playback.nextIndex);},`${playbackIdentity}:${restart}`);
  const progressEstimates=useMemo(()=>{
    if(index===undefined)return {current:estimate,next:estimate};
    return {current:estimateWalkingActivity(points.slice(0,index+1),profile?.strideCm??NaN,profile?.weightKg??NaN),next:estimateWalkingActivity(points.slice(0,Math.min(points.length,index+2)),profile?.strideCm??NaN,profile?.weightKg??NaN)};
  },[points,index,profile?.strideCm,profile?.weightKg,estimate]);
  const progressValue=(key:'distanceKm'|'activeMinutes')=>{const a=progressEstimates.current[key],b=progressEstimates.next[key];return a==null?null:b==null?a:a+(b-a)*playbackFraction;};
  const progressDistance=index===undefined?route?.distanceKm??estimate.distanceKm:progressValue('distanceKm'),progressMinutes=index===undefined?estimate.activeMinutes:progressValue('activeMinutes');
  const progressSpeed=progressDistance!=null&&progressMinutes!=null&&progressMinutes>0?progressDistance/(progressMinutes/60):null;
  const progressTime=index===undefined?null:Date.parse(points[index].receivedAt);
  useEffect(()=>{if(playing&&!playback)setPlaying(false);},[playing,playback?.nextIndex]);
  const movePeriod=(direction:1|-1)=>{const next=shiftDateRange(date,endDate,direction);if(!next||next.start<'1970-01-01'||next.end>displayDateKey())return;setPlaying(false);setCursor(undefined);setDate(next.start);setEndDate(next.end);setUrlQuery({start:next.start,end:next.end});};
  const change = (next: string) => {
      if (validDateKey(next)) {
        setPlaying(false);
        setCursor(undefined);
        setDate(next);setEndDate(next);setUrlQuery({start:next,end:next});
        setDraft(next);
        setEdit(false);
        if(next===date)void session.loadRoute(bounds.startAt,bounds.endAt,true,timeBasis);
      }
    },
    number = (v: number | null | undefined, digits = 0) =>
      v == null
        ? copy("Mangler")
        : new Intl.NumberFormat(locale, {
            maximumFractionDigits: digits,
          }).format(v),
    wrap = {
      flexDirection: design.accessible ? "column" : "row",
      flexWrap: "wrap",
      gap: spacing.sm,
    } as const;
  return (
    <Page
      title={prettyDate(date, locale)+(endDate!==date?"  -  "+prettyDate(endDate,locale):"")}
      subtitle={locale==='da-DK'?"Tryk Afspil for at følge ruten. Træk tidslinjen for at vælge en GPS-position. Lange pauser springes over.":"Press Play to follow the route. Drag the timeline to choose a GPS position. Long gaps are skipped."}
      eyebrow="Positionshistorik"
      testID="route-playback-screen"
    >
      <RouteRangePicker start={date} end={endDate} locale={locale} color={colors.text} surface={colors.surface} disabled={state.routeBusy} onApply={(from,to)=>{setPlaying(false);setCursor(undefined);setDate(from);setEndDate(to);setUrlQuery({start:from,end:to});if(from===date&&to===endDate)void session.loadRoute(bounds.startAt,bounds.endAt,true,timeBasis);}}/>
      <ButtonRow columns={3}>
        <Button
          label={date===endDate?"Forrige dag":locale==='da-DK'?"Forrige periode":"Previous period"}
          icon="back"
          tone="secondary"
          disabled={date <= "1970-01-01"}
          onPress={() => movePeriod(-1)}
        />
        <Button
          label="I dag"
          icon="calendar"
          tone="secondary"
          onPress={() => change(displayDateKey())}
        />
        <Button
          label={date===endDate?"Næste dag":locale==='da-DK'?"Næste periode":"Next period"}
          icon="chevron"
          tone="secondary"
          disabled={(shiftDateRange(date,endDate,1)?.end??date)>displayDateKey()}
          onPress={() => movePeriod(1)}
        />
      </ButtonRow>
      {state.routeBusy ? (
        <StatePanel state="loading" />
      ) : state.routeError ? (
        <StatePanel
          state="error"
          actionLabel="Prøv igen"
          onAction={() =>
            void session.loadRoute(bounds.startAt, bounds.endAt,true,timeBasis)
          }
        />
      ) : receiptArchive ? (
        <Card><SectionTitle>{locale==='da-DK'?'Modtagne GPS-punkter':'Received GPS points'}: {points.length}</SectionTitle>{points.slice(0,50).map(p=><View key={p.id}><Text style={{color:colors.text}}>{locale==='da-DK'?'Modtaget: ':'Received: '}{new Date(p.receivedAt).toLocaleString(locale,{timeZone:displayTimeZone()})}</Text><Text style={{color:colors.textMuted}}>{locale==='da-DK'?'GPS målt: ':'GPS measured: '}{p.measuredAt?new Date(p.measuredAt).toLocaleString(locale,{timeZone:displayTimeZone()}):(locale==='da-DK'?'Tid ubekræftet':'Time unconfirmed')}</Text></View>)}{points.length>50&&<Text style={{color:colors.textMuted}}>{locale==='da-DK'?"Viser de første 50 positioner.":"Showing the first 50 positions."}</Text>}</Card>
      ) : !points.length ? (
        <StatePanel
          state={state.networkUnavailable ? "offline" : "empty"}
          title={
            state.networkUnavailable ? undefined : "Ingen registreringer endnu"
          }
        />
      ) : (
        <>
          <Card>
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                gap: spacing.md,
              }}
            >
              <Metric
                label="Rutedistance"
                value={progressDistance==null?copy("Ikke rapporteret"):`${number(progressDistance, 2)} km`}
                icon="route"
              />
              <Metric
                label="Aktiv tid"
                value={progressMinutes==null?copy("Ikke rapporteret"):`${number(progressMinutes)} min.`}
                icon="active-time"
              />
              <Metric
                label="Tidspunkt"
                value={
                  progressTime === null
                    ? copy("Vælg et punkt")
                    : new Date(progressTime).toLocaleString(
                        locale,
                        {
                          day: "2-digit", month: "short",
                          hour: "2-digit", minute: "2-digit", second: "2-digit",
                          timeZone: displayTimeZone(),
                        },
                      )
                }
                icon="clock"
              />
              <Metric label="Aktuel hastighed" value={index===undefined?copy('Vælg et punkt'):typeof points[index].speedKph==='number'&&Number.isFinite(points[index].speedKph)&&points[index].speedKph>=0?number(points[index].speedKph,1)+(locale==='da-DK'?' km/t':' km/h'):copy('Ikke rapporteret')} icon="speed"/>
              <Metric label="Gns. hastighed" value={progressSpeed==null?copy('Mangler'):`${number(progressSpeed,1)} ${locale==='da-DK'?'km/t':'km/h'}`} icon="speed"/>
            </View>
            <MapSlot inCard route={points} playbackIndex={index} playbackFraction={playbackFraction} />
            <RouteTimeline count={points.length} index={index} locale={locale} color={colors.primary} surface={colors.surfaceSoft} onSeek={i=>{setPlaying(false);setRestart(n=>n+1);setCursor(i);}}/>
            {index !== undefined &&
              index > 0 &&
              !points[index].connectFromPrevious && (
                <Pill tone={estimatedCurrent ? "neutral" : "attention"} icon={estimatedCurrent ? "route" : "warning"}>
                  {estimatedCurrent ? (locale==='da-DK'?"Ingen registreret GPS-position":"No recorded GPS position") : "Lang pause eller usikkert positionsspring"}
                </Pill>
              )}
            <ButtonRow columns={4} minItemWidth={125}>
              <Button
                label={playing ? "Pause" : "Afspil"}
                icon={playing ? "pause" : "play"}
                disabled={points.length < 2}
                onPress={() => {
                  if (playing) setPlaying(false);
                  else {
                    if (index === undefined || index >= points.length - 1)
                      setCursor(0);
                    setPlaying(true);
                  }
                }}
              />
              <Button
                label="Genstart"
                icon="replay"
                tone="secondary"
                onPress={() => {
                  setRestart(value=>value+1);
                  setCursor(0);
                  setPlaying(false);
                }}
              />
              <Button
                label="Tilbage"
                icon="back"
                tone="secondary"
                disabled={index === undefined || index === 0}
                onPress={() => {
                  setPlaying(false);
                  setCursor(Math.max(0, (index ?? 0) - 1));
                }}
              />
              <Button
                label="Frem"
                icon="chevron"
                tone="secondary"
                disabled={index !== undefined && index >= points.length - 1}
                onPress={() => {
                  setPlaying(false);
                  setCursor(Math.min(points.length - 1, (index ?? -1) + 1));
                }}
              />
            </ButtonRow>
            <Button label={locale==='da-DK'?"Vis hele historikken":"Show full history"} icon="route" tone="secondary" onPress={()=>{setPlaying(false);setRestart(n=>n+1);setCursor(undefined);}}/>
            <Segmented
              label="Afspilningshastighed"
              value={speed}
              onChange={setSpeed}
              options={[
                { value: "0.5", label: "0,5×" },
                { value: "1", label: "1×" },
                { value: "2", label: "2×" },
                { value: "4", label: "4×" },
              ]}
            />
            <View style={{gap:spacing.sm,paddingTop:spacing.sm}}>
              <Info title={locale==='da-DK'?'Registreret GPS-rute':'Recorded GPS route'} icon="route" palette={{ink:colors.text,muted:colors.textMuted,primary:colors.primary,primarySoft:colors.surfaceSoft,line:colors.border}}><Text style={{color:colors.textMuted,fontSize:type.body,lineHeight:type.line}}>{locale==='da-DK'?'Den grønne linje følger de GPS-positioner, som enheden faktisk har registreret.':'The green line follows the GPS positions the device actually recorded.'}</Text></Info>
              <Info title={locale==='da-DK'?'Ingen registreret GPS-position':'No recorded GPS position'} icon="gps" palette={{ink:colors.text,muted:colors.textMuted,primary:colors.primary,primarySoft:colors.surfaceSoft,line:colors.border}}><Text style={{color:colors.textMuted,fontSize:type.body,lineHeight:type.line}}>{locale==='da-DK'?'Den lyse, stiplede linje forbinder GPS-positionerne før og efter en periode uden registreret GPS. Den viser ikke en målt rute.':'The light dashed line connects GPS positions before and after a period without recorded GPS. It is not a measured route.'}</Text></Info>
            </View>
          </Card>
          {state.snapshot?.device?.profile?.features.includes('activity')&&<Button
            label="Åbn aktivitetsdagen"
            icon="activity"
            tone="secondary"
            onPress={() => onActivityDay(date)}
          />}
        </>
      )}
      {gt06&&<Card><SectionTitle>{locale==='da-DK'?(receiptArchive?'Modtagelsesarkiv':"Positionens tidspunkt"):(receiptArchive?'Receipt archive':'GPS measurement time')}</SectionTitle><Text style={{color:colors.textMuted}}>{locale==='da-DK'?(receiptArchive?"Datoen viser, hvornår Qtracker modtog positionerne. GPS-måletid vises separat.":"Ruten vises efter GPS-måletid. Modtagelsesarkivet viser, hvornår Qtracker modtog oplysningerne."):(receiptArchive?'The date shows when Qtracker received the points. GPS measurement time is shown separately.':'Routes use confirmed GPS measurement time. Delayed points appear on the day they were measured.')}</Text>{clockConfirmed&&<Button tone="secondary" label={locale==='da-DK'?(archive?'Vis rute efter GPS-måletid':'Vis modtagelsesarkiv'):(archive?'Show route by GPS time':'Show receipt archive')} onPress={()=>{setArchive(v=>!v);setUrlQuery({basis:archive?'measured':'receipt'});setPlaying(false);setCursor(undefined);}}/>}</Card>}
    </Page>
  );
}
function Measure() {
  const { state, tracker } = useLive();
  const scope = JSON.stringify([
    state.address,
    state.accountEmail,
    state.signedIn,
    tracker.entity.deviceId,
    tracker.entity.personName,
  ]);
  return (
    <Page
      title="Ny måling"
      eyebrow={tracker.entity.personName}
      subtitle="Målingerne er vejledende og kan ikke erstatte en lægefaglig vurdering."
      testID="measurement-screen"
    >
      <MeasurementFlow key={scope} scope={scope} />
    </Page>
  );
}
function Medicine() {
  const live = useLive(),
    [slot, setSlot] = useState("1");
  return (
    <Page
      title="Medicinpåmindelser"
      eyebrow="Tre pladser på denne model"
      subtitle="Vælg din påmindelse, og tryk Gem"
      testID="medication-screen"
    >
      <Segmented
        label="Vælg påmindelse"
        value={slot}
        onChange={setSlot}
        options={[1, 2, 3].map((i) => ({
          value: String(i),
          label: `Påmindelse ${i}`,
        }))}
      />
      <HardwareSettingCard
        key={slot}
        {...live}
        type="TAKEPILLS"
        slot={Number(slot)}
        delivered
      />
    </Page>
  );
}
function EventDetail({ id }: { id: string }) {
  const { events, tracker, actions, state } = useLive(),
    { colors, spacing, type } = useTokens(),
    event = events.find((e) => e.id === id);
  if (!event)
    return (
      <Page title="Hændelse">
        <StatePanel state="empty" />
      </Page>
    );
  return (
    <Page
      title={event.title}

      testID="event-detail-screen"
    >
      <Card><Row title="Enhed" value={tracker.entity.personName} icon="device"/><Row title="Modtaget" value={event.occurredAt} icon="clock"/></Card>
      <Card tone={event.tone}>
        <View
          style={{
            flexDirection: "row",
            gap: spacing.md,
            alignItems: "center",
          }}
        >
          <Icon
            name={
              event.type === "sos"
                ? "sos"
                : event.type === "fall"
                  ? "fall"
                  : event.type.includes("zone")
                    ? "safe-zone"
                    : "event"
            }
            size={48}
            color={event.tone === "critical" ? colors.critical : colors.primary}
          />
          <View style={{ flex: 1, gap: spacing.xs }}>
            <Text
              style={{
                color: colors.text,
                fontSize: type.heading,
                fontWeight: "800",
              }}
            >
              {event.handledAt ? "Håndteret" : "Afventer håndtering"}
            </Text>
            <Text style={{ color: colors.textMuted, fontSize: type.body }}>
              {event.handledAt
                ? `${event.handledAt} · ${event.handledBy ?? ""}`
                : "Ingen har markeret hændelsen som håndteret"}
            </Text>
          </View>
        </View>
      </Card>
      <Button
        label="Ring til armbåndet"
        icon="call"
        onPress={() => actions.openScreen("care-call")}
      />
      <Button
        label="Se position"
        icon="map"
        tone="secondary"
        onPress={() => actions.goToTab("position")}
      />
      {!event.handledAt && (
        <Button
          label="Markér som håndteret"
          icon="confirm"
          disabled={state.busy || state.snapshot?.device?.access?.canAcknowledge===false}
          onPress={() => void actions.acknowledgeEvent(id)}
        />
      )}
      <Pill tone="attention" icon="confirm">
        Markér hændelsen som håndteret, når du har fulgt op. Kontrollér selv, om der er brug for mere hjælp.
      </Pill>
    </Page>
  );
}
function Find() {
  const { state, session, tracker, locale } = useLive(),
    now = useNow(),
    progress = state.findProgress,
    found = ["accepted", "sent", "replied"].includes(progress ?? "");
  return (
    <Page
      title="Find armbåndet"
      subtitle={petProfile(state.snapshot?.device?.profile)?(locale==="da-DK"?"Bed trackeren afspille en ringetone. Markering som fundet stopper ikke lyden på afstand.":"Ask the tracker to play a ringtone. Marking it found does not stop the sound remotely."):"Lyden varer cirka ét minut. Den stoppes på enheden."}
      eyebrow={tracker.entity.deviceId}
      testID="find-device-screen"
    >
      {progress === "sending" ? null : found ? (
        <Card tone="positive">
          <Pill tone="positive" icon="sound">
            Anmodning sendt til armbåndet
          </Pill>
          <Button
            label="Jeg har fundet armbåndet"
            icon="check"
            onPress={() => session.confirmTrackerFound()}
          />
        </Card>
      ) : (
        <Card>
          <Button
            label="Afspil ringetone"
            icon="find-device"
            disabled={
              state.busy ||
              !state.snapshot?.device?.connected ||
              findWaitSeconds(state.snapshot, now) > 0
            }
            onPress={() => void session.findTracker(true)}
          />
        </Card>
      )}
      {!state.snapshot?.device?.connected && <StatePanel state="offline" />}
      {["failed", "unconfirmed"].includes(progress ?? "") && (
        <StatePanel state="error" title="Anmodningen er ikke bekræftet" />
      )}
      <Pill tone="info" icon="sound">
        “Fundet” stopper ikke lyden på afstand.
      </Pill>
    </Page>
  );
}
type PowerPlan = { mode: string; time: string; enabled: boolean; days: string };
function Power() {
  const live=useLive();
  if(wonlexCareProfile(live.state.snapshot?.device?.profile))return <Page title={live.locale==='da-DK'?'Strøm og genstart':'Power and restart'}><HardwareSettingsPanel {...live} featureId="restart"/><HardwareSettingsPanel {...live} featureId="powerOff"/><HardwareSettingsPanel {...live} featureId="factoryReset"/></Page>;
  return <CareBandPower/>;
}
function CareBandPower() {
  const live = useLive(),
    { tracker, state, locale } = live,
    [mode, setMode] = useState<HardwareCommandType | null>(null);
  const saved = (mode: string) => {
    const command = state.snapshot?.hardware?.commands.find(
      (c) =>
        c.type === "SPOF" &&
        hardwareParameters(c.type, c.payload)?.mode === mode,
    );
    return command ? hardwareParameters(command.type, command.payload) : null;
  };
  const incomingOn = saved("on") as PowerPlan | null,
    incomingOff = saved("off") as PowerPlan | null;
  const [onPlan, setOnPlan] = useState<PowerPlan>(
      () =>
        incomingOn ?? {
          mode: "on",
          time: "07:00",
          enabled: false,
          days: "1111111",
        },
    ),
    [offPlan, setOffPlan] = useState<PowerPlan>(
      () =>
        incomingOff ?? {
          mode: "off",
          time: "22:00",
          enabled: false,
          days: "1111111",
        },
    );
  const subtitle = (plan: typeof onPlan, incoming: unknown) =>
    incoming
      ? `${plan.time} · ${locale === "da-DK" ? "se ugedage i tidsplanen" : "see weekdays in schedule"}`
      : locale === "da-DK"
        ? "Intet tidspunkt gemt"
        : "No saved time";
  return (
    <Page
      title="Tidsplaner og strøm"
      subtitle="Handlinger, der kan afbryde kontakt og alarmer, kræver konkret bekræftelse"
      eyebrow={`${tracker.entity.trackerName} · ${tracker.entity.deviceId}`}
      testID="power-screen"
    >
      <Card>
        <SectionTitle>Tidsplaner</SectionTitle>
        <SwitchRow
          title="Tænd automatisk"
          subtitle={subtitle(onPlan, incomingOn)}
          value={onPlan.enabled}
          onValueChange={(enabled) => {
            setOnPlan({ ...onPlan, enabled });
            setMode(null);
          }}
        />
        <SwitchRow
          title="Sluk automatisk"
          subtitle={subtitle(offPlan, incomingOff)}
          value={offPlan.enabled}
          onValueChange={(enabled) => {
            setOffPlan({ ...offPlan, enabled });
            setMode(null);
          }}
        />
        <Button
          label="Redigér tidsplaner"
          icon="edit"
          onPress={() => setMode("SPOF")}
        />
      </Card>
      <Card>
        <SectionTitle>Enhedshandlinger</SectionTitle>
        <Row
          title="Genstart armbåndet"
          subtitle="Kontakt afbrydes midlertidigt"
          icon="restart"
          onPress={() => setMode("RESET")}
        />
        <Row
          title="Sluk armbåndet"
          subtitle="Kontakt og alarmer stopper, indtil det tændes igen"
          icon="power"
          tone="attention"
          onPress={() => setMode("POWEROFF")}
        />
        <Row
          title="Fabriksnulstil"
          subtitle="Enheden skal sættes op igen. Historikken i Qtracker bevares."
          icon="reset"
          tone="critical"
          onPress={() => setMode("FACTORY")}
        />
      </Card>
      {mode === "SPOF" ? (
        <>
          <HardwareSettingCard
            {...live}
            type="SPOF"
            slot={1}
            delivered
            initialDraft={onPlan}
          />
          <HardwareSettingCard
            {...live}
            type="SPOF"
            slot={2}
            delivered
            initialDraft={offPlan}
          />
        </>
      ) : (
        mode && (
          <HardwareSettingCard key={mode} {...live} type={mode} delivered />
        )
      )}
    </Page>
  );
}
function Zone() {
  const { state } = useLive();
  return state.snapshot?.device?.capabilities?.gpsZones ? (
    <NamedZonesScreen />
  ) : (
    <LegacyZone />
  );
}
function LegacyZone() {
  const { state, session, position, actions } = useLive(),
    saved = state.snapshot?.device?.gpsZone,
    { colors, spacing, design } = useTokens(),
    [draft, setDraft] = useState(() => ({
      enabled: saved?.enabled ?? true,
      latitude: saved?.latitude ?? position?.latitude ?? 0,
      longitude: saved?.longitude ?? position?.longitude ?? 0,
      radiusMeters: saved?.radiusMeters ?? 250,
      notify: saved?.notify ?? "both",
    })),
    [revision, setRevision] = useState(
      state.snapshot?.device?.gpsZoneRevision ?? saved?.revision ?? 0,
    ),
    [removing, setRemoving] = useState(false),
    [chosen, setChosen] = useState(Boolean(saved || position)),
    [dirty, setDirty] = useState(false),
    [review, setReview] = useState(false);
  const patch = (values: Partial<typeof draft>) => {
      setDraft({ ...draft, ...values });
      setDirty(true);
      setReview(false);
      setRemoving(false);
    },
    conflict =
      (state.snapshot?.device?.gpsZoneRevision ?? saved?.revision ?? 0) !==
      revision;
  return (
    <Page
      title="GPS-sikkerhedszone"
      subtitle="Zonen vurderes først, når en ny brugbar GPS-position modtages"
      eyebrow="Trygt område"
      testID="gps-zone-screen"
    >
      <MapSlot
        zone={chosen ? draft : undefined}
        onPick={(point) => {
          patch(point);
          setChosen(true);
        }}
        label={`GPS-zone · ${draft.radiusMeters} m`}
      />
      <Card>
        <Row title="Navn på området" value="GPS-sikkerhedszone" />
        <Row
          title="Radius"
          value={`${draft.radiusMeters} meter`}
          icon="radius"
        />
        <ButtonRow columns={2}>
          <Button
            label="− 50 m"
            tone="secondary"
            disabled={draft.radiusMeters <= 50}
            onPress={() =>
              patch({ radiusMeters: Math.max(50, draft.radiusMeters - 50) })
            }
          />
          <Button
            label="+ 50 m"
            tone="secondary"
            disabled={draft.radiusMeters >= 5000}
            onPress={() =>
              patch({ radiusMeters: Math.min(5000, draft.radiusMeters + 50) })
            }
          />
        </ButtonRow>
        <SwitchRow
          title="Sikkerhedszonen er aktiv"
          value={draft.enabled}
          onValueChange={(enabled) => patch({ enabled })}
        />
        <Segmented
          label="Hvornår skal der gives besked"
          value={draft.notify}
          onChange={(notify) => patch({ notify })}
          options={[
            { value: "enter", label: "Ved ankomst" },
            { value: "exit", label: "Ved afgang" },
            { value: "both", label: "Begge dele" },
          ]}
        />
        <Pill
          tone={dirty ? "attention" : "info"}
          icon={dirty ? "edit" : "safe-zone"}
        >
          {dirty
            ? "Ændringerne er ikke gemt"
            : saved
              ? "Dit valg er gemt"
              : "Vælg centrum på kortet"}
        </Pill>
      </Card>
      {conflict && (
        <StatePanel
          state="error"
          title="Zonen er ændret siden åbning"
          actionLabel="Genindlæs"
          onAction={() => {
            if (saved) {
              setDraft({
                enabled: saved.enabled,
                latitude: saved.latitude,
                longitude: saved.longitude,
                radiusMeters: saved.radiusMeters,
                notify: saved.notify,
              });
              setChosen(true);
            } else {
              setChosen(false);
            }
            setRevision(
              state.snapshot?.device?.gpsZoneRevision ?? saved?.revision ?? 0,
            );
            setDirty(false);
            setReview(false);
            setRemoving(false);
          }}
        />
      )}
      <Button
        label="Gem zone"
        icon="confirm"
        disabled={
          !dirty ||
          !chosen ||
          !validZone(draft) ||
          conflict ||
          (state.busy&&!state.autoRefreshing) ||
          !state.snapshot?.device?.capabilities?.gpsZone
        }
        onPress={()=>session.saveGpsZone(draft,revision).then(ok=>{if(ok)actions.goBack();return ok;})}
      />
      <Button
        label="Annullér ændringer"
        icon="cancel"
        tone="quiet"
        onPress={actions.goBack}
      />
      {saved &&
        state.snapshot?.device?.capabilities?.gpsZoneDelete &&
        (removing ? (
          <Card tone="attention">
            <SectionTitle>Fjern sikkerhedszonen?</SectionTitle>
            <Text style={{ color: colors.text }}>
              Nye zonehændelser stopper. Gemte positioner og hændelser bevares.
            </Text>
            <Button
              label="Fjern zone"
              icon="delete"
              tone="danger"
              disabled={state.busy || conflict}
              onPress={() =>
                void session.deleteGpsZone(revision, true).then((ok) => {
                  if (ok) actions.goBack();
                })
              }
            />
            <Button
              label="Annullér"
              tone="quiet"
              disabled={state.busy}
              onPress={() => setRemoving(false)}
            />
          </Card>
        ) : (
          <Button
            label="Fjern zone"
            icon="delete"
            tone="danger"
            disabled={state.busy || conflict}
            onPress={() => {
              setRemoving(true);
              setReview(false);
            }}
          />
        ))}
    </Page>
  );
}
function Detail({ id }: { id: string }) {
  const {selectAppearance}=useLayout();
  const live = useLive(),
    { state, session, actions, locale, palette, tracker } = live,
    { colors, spacing, type } = useTokens(),
    feature = {...getFeature(id),...(wonlexCareProfile(state.snapshot?.device?.profile)?wonlexFeatureCopy(id,locale):{})},
    [choice, setChoice] = useState("heartPressure"),
    [name, setName] = useState(modelName(state.snapshot?.device?.displayName)),
    [password, setPassword] = useState<"account" | "tracker" | null>(null);
  const hardware = (featureId: string) => (
    <HardwarePanel {...live} featureId={featureId} />
  );
  const settings = (featureId: string) => (
    <HardwareSettingsPanel {...live} featureId={featureId} delivered />
  );
  let content: React.ReactNode;
  if (id === "position-frequency") content = <Frequency />;
  else if (id === "position-quality") content = <Quality />;
  else if (id === "position-sources")
    content = (
      <>
       <Card><SectionTitle>{locale==='da-DK'?'Vælg hvilke positioner der må vises':'Choose which positions may be shown'}</SectionTitle>
        <Text style={{color:colors.textMuted,fontSize:type.body,lineHeight:type.line}}>{locale==='da-DK'?'GPS er normalt mest præcis udendørs. Indendørs kan der gå længere tid, før en ny GPS-position kan vises.':'GPS is usually most accurate outdoors. Indoors, a new GPS position may take longer to appear.'}</Text>
        <Row title={locale==='da-DK'?'Kun GPS':'GPS only'} value={locale==='da-DK'?'Valgt':'Selected'} icon="gps" tone="positive"/>
        <Row title={locale==='da-DK'?'GPS og omtrentlige positioner':'GPS and approximate positions'} value={locale==='da-DK'?'Ikke tilgængelig endnu':'Not available yet'} icon="wifi" tone="attention"/>
        <Pill tone="attention" icon="wifi">{locale==='da-DK'?"Omtrentlige positioner via Wi-Fi og mobilmaster er ikke tilgængelige endnu.":"Approximate positions from Wi-Fi and mobile towers are not available yet."}</Pill>
       </Card>
       <Card><SectionTitle>{locale==='da-DK'?'Når GPS-signalet mangler':'When GPS signal is unavailable'}</SectionTitle>
        <Row title={locale==='da-DK'?'Aktuel positionskilde':'Current position source'} value="GPS" icon="gps"/>
        <Text style={{color:colors.textMuted,fontSize:type.body,lineHeight:type.line}}>{locale==='da-DK'?'Når en ny rapport ikke indeholder en gyldig GPS-position, beholdes den senest kendte GPS-position med sit tidspunkt. Rapporten bliver ikke vist som en ny præcis position.':'When a new report has no valid GPS position, the last known GPS position remains visible with its timestamp. The report is not shown as a new precise position.'}</Text>
        <Text style={{color:colors.textMuted,fontSize:type.body,lineHeight:type.line}}>{wonlexCareProfile(state.snapshot?.device?.profile)?(locale==='da-DK'?'Uret bruger GPS, når det kan modtage satellitsignaler.':'The watch uses GPS when satellite signals are available.'):(locale==='da-DK'?'GPS kan ikke slås fra i appen.':'GPS cannot be turned off in the app.')}</Text>
       </Card>
      </>
    );
  else if (id === "position-wifi-zone") content = settings("wifiFence");
  else if (id === "care-history") content = <HealthHistory/>;
  else if (id === "care-schedules")
    content = (
      <>
        {settings("heartPressure")}
        {settings("temperature")}
      </>
    );
  else if (id === "care-thresholds") content = <><MeasurementAlertPanel/>{wonlexCareProfile(state.snapshot?.device?.profile)&&settings("temperatureAlerts")}</>;
  else if (id === "care-voice") content = <VoiceMessagesPanel/>;
  else if (id === "care-call") content = <TrackerCallPanel {...live} />;
  else if (id === "care-callback") content = settings("voiceMonitor");
  else if (id === "activity-profile") content = <Profile />;
  else if (id === "activity-device-steps")
    content = (
      <>
        <Card>
          <Metric
            label="Skridttæller"
            value={
              state.snapshot?.device?.steps == null
                ? "Mangler"
                : state.snapshot.device.steps.toLocaleString(locale)
            }
            icon="steps"
          />
        </Card>
        {hardware("steps")}
      </>
    );
  else if (id === "device-info")
    content = (
      <>
        <Card>
          <DevicePhotoEditor/>
          <Field label="Trackerens navn" value={name} onChangeText={setName} />
          <Button
            label="Gem navn"
            icon="confirm"
            disabled={(state.busy&&!state.autoRefreshing) || state.snapshot?.device?.access?.canConfigure===false || !name.trim() || name.length > 40}
            onPress={() => session.updateDeviceName(name)}
          />
<Row title="IMEI / producent-ID" value={customerDeviceIdentity(state.snapshot?.device)??"Ukendt"} icon="sim"/>
          <Row title="Model" value={modelName(state.snapshot?.device?.profile)} leading={<ModelIcon profile={state.snapshot?.device?.profile} size={24}/>}/>
          {petProfile(state.snapshot?.device?.profile)&&<Row title="Batterikapacitet" value={`${petProfile(state.snapshot?.device?.profile)!.batteryMah} mAh`} icon="battery"/>}
          <Row title="Telefonnummer" value={state.snapshot?.device?.contact?.phoneNumber??"Ukendt"} icon="phone"/>
          <Row
            title="SIM-ICCID"
            value={state.snapshot?.device?.reportedInfo?.sim?.value ?? "Ukendt"}
            icon="sim"
          />
          <Row
            title="Appversion"
            value={Constants.expoConfig?.version ?? "—"}
            icon="overview"
          />
          <Row
            title="Firmwareversion"
            value={
              state.snapshot?.device?.reportedInfo?.firmware?.value ?? state.snapshot?.device?.profile?.firmware ?? "Ukendt"
            }
            icon="refresh"
          />
        </Card>
        {state.snapshot?.device?.capabilities?.deviceContact&&<TrackerCallPanel {...live} />}
      </>
    );
  else if(id==='care-message')content=settings('message');
  else if (id === "device-sos") content = settings("sosNumbers");
  else if(id === "device-phonebook")content = <PhonebookPanel/>;
  else if (id === "device-sms") content = settings("smsAlarm");
  else if (id === "device-wrist") content = hardware("removalAlarm");
  else if (id === "device-fall")
    content = <FallAlarmSettingsPanel key={state.snapshot?.device?.id} locale={locale} palette={palette} state={state} session={session}/>;
  else if (id === "device-sound")
    content = (
      <>
        {hardware("sceneMode")}
        {settings("answerMode")}
      </>
    );
  else if (id === "device-safe-mode") content = settings("safeMode");
  else if (id === "device-clock")
    content = (
      <>
        {settings("alarmClock")}
        {settings("speakingClock")}
        {settings("callerId")}
      </>
    );
  else if (id === "device-language-time")
    content = <TimePolicyPanel/>;
  else if (id === "device-account")
    content = (
      <>
        <Card>
          <Row
            title="Logget ind som"
            value={state.accountEmail ?? "—"}
            icon="account"
          />
          <Button
            label="Skift adgangskode"
            icon="password"
            tone="secondary"
            onPress={() => setPassword("account")}
          />
          {Platform.OS!=="web"&&!wonlexCareProfile(state.snapshot?.device?.profile)&&<Button
            label="Skift sekscifret SMS-kode"
            disabled={state.snapshot?.device?.access?.canConfigure===false}
            icon="sim"
            tone="secondary"
            onPress={() => setPassword("tracker")}
          />}
          <Button
            label="Log ud"
            icon="logout"
            tone="quiet"
            onPress={live.onLogout}
          />
        </Card>
        {password === "account" && (
          <AccountPasswordModal
            {...live}
            onClose={() => setPassword(null)}
            onTracker={Platform.OS!=="web"&&!wonlexCareProfile(state.snapshot?.device?.profile)?()=>setPassword("tracker"):undefined}
          />
        )}{" "}
        {Platform.OS!=="web" && password === "tracker" && (
          <TrackerPasswordModal {...live} onClose={() => setPassword(null)} />
        )}
      </>
    );
  else if (id === "device-app-settings")
    content = (
      <Card>
        <SectionTitle>App-indstillinger</SectionTitle>
        <TimeZonePanel/>
        <AppearanceControls palette={palette} disabled={state.layoutBusy} onSelect={patch=>{selectAppearance(patch);void session.saveAppearance(patch);}}/>
        {(state.snapshot?.devices.length ?? 0) > 1 &&
          state.snapshot!.devices.map((device) => (
            <Row
              key={device.id}
              title={productDeviceName(device)}
              icon="device"
              value={device.id === tracker.entity.deviceId ? "Valgt" : ""}
              onPress={() => void session.selectDevice(device.id)}
            />
          ))}
      </Card>
    );
  else if (id === "device-help")
    content = <HelpPanel locale={locale} palette={palette} />;
  else
    content = (
      <StatePanel
        state="unsupported"
        title={feature?.title ?? "Ikke understøttet endnu"}
        message={locale==="da-DK"?"Denne funktion er ikke tilgængelig på enheden endnu.":"This feature is not available on the device yet."}
      />
    );
  return (
    <Page title={feature?.title ?? "Funktion"} subtitle={Platform.OS === "web" && id === "device-account" ? (locale === "da-DK" ? "Login, sessioner og adgangskoden til din Qtracker-konto." : "Login, sessions and your Qtracker account password.") : feature?.summary}>
      <FeatureSupportNote
        key={id}
        id={id}
        locale={locale}
        color={colors.textMuted}
      />
      {feature?.help && (
        <Text
          style={{
            color: colors.text,
            fontSize: type.bodyLarge,
            lineHeight: type.bodyLarge + 7,
          }}
        >
          {Platform.OS === "web" && id === "device-account" ? (locale === "da-DK" ? "En ændret kontoadgangskode logger eksisterende kontosessioner ud." : "Changing the account password signs existing sessions out.") : feature.help}
        </Text>
      )}
      {content}
    </Page>
  );
}
function Frequency() {
  const { state, session, locale, palette } = useLive(),
    device = state.snapshot?.device,
    raw = Number(device?.uploadCommand?.payload?.split(",")[1]),
    [interval, setIntervalValue] = useState(
      validUploadInterval(raw) ? raw : raw===10?30:60,
    ),
    now = useNow(),
    wait = uploadWaitSeconds(state.snapshot, now);
  const request = uploadRequestState(device?.uploadCommand);
  return (
    <>
      <Card>
        <SectionTitle>Positionsinterval</SectionTitle>
        <StepSlider
          label={translate(locale, "product.upload")}
          values={UPLOAD_INTERVALS}
          value={interval}
          onChange={(v) => {
            setIntervalValue(v);
          }}
          format={(v) => intervalLabel(v, locale)}
          palette={palette}
        />
        <Row
          title="Senest anmodede interval"
          value={
            request.seconds !== null
              ? intervalLabel(request.seconds, locale)
              : "Ikke bekræftet"
          }
          icon="clock"
        />
        <Text style={{color:palette.muted,fontSize:16,lineHeight:24}}>{translate(locale, `product.uploadRequest.${request.state}`)}</Text>
        <Pill tone="info" icon="battery">
          Hyppigere positioner bruger normalt mere strøm
        </Pill>
      </Card>
      <Button
        label="Gem interval"
        icon="confirm"
        disabled={(state.busy&&!state.autoRefreshing)||!device?.connected||wait>0||!device.capabilities?.uploadInterval}
        onPress={()=>{void session.setUploadInterval(interval,true);}}
      />
    </>
  );
}
function Quality() {
  const { state, session, locale, palette } = useLive(),
    summary = state.snapshot?.telemetry,
    [period, setPeriod] = useState(state.telemetryMinutes),
    number = (v: number | null | undefined) =>
      v == null ? "—" : v.toLocaleString(locale);
  return (
    <Card>
      <SectionTitle>{locale==='da-DK'?'Vis data for de seneste …':'Show data for the last …'}</SectionTitle>
      <StepSlider
        label={translate(locale, "product.period")}
        values={TELEMETRY_WINDOWS}
        value={period}
        onChange={setPeriod}
        onCommit={(v) => void session.setTelemetryWindow(v)}
        format={(v) => intervalLabel(v * 60, locale)}
        palette={palette}
        disabled={state.busy}
      />
      <Text style={{color:palette.muted,fontSize:16,lineHeight:24}}>{translate(locale,"product.qualityHelp")}</Text>
      <Row
        title="Brugbare GPS-positioner"
        value={`${number(summary?.validGpsCount)} / ${number(summary?.reportCount)}`}
        icon="gps"
      />
      <Row
        title="Længste pause"
        value={
          summary?.maxGapSeconds == null
            ? "—"
            : `${number(Math.round(summary.maxGapSeconds / 60))} min.`
        }
        icon="clock"
      />
      <Row
        title="Batteri"
        value={qualityBatteryLabel(summary,locale)} subtitle={summary?.batteryChargingObserved?(locale==='da-DK'?'Opladning er registreret i perioden; ændringen viser ikke rent forbrug.':'Charging was recorded in this period; the change does not represent consumption alone.'):undefined}
        icon="battery"
      />
      <Row
        title="GPS-rutedistance"
        value={
          summary?.routeDistanceKm == null
            ? "—"
            : `${summary.routeDistanceKm.toLocaleString(locale,{maximumFractionDigits:2})} km`
        }
        icon="route"
      />
    </Card>
  );
}

function Profile() {
  const {colors}=useTokens();
  const { state, session, actions, locale, palette } = useLive(),
    profile = state.snapshot?.device?.activityProfile;
  const [stride, setStride] = useState(profile ? String(profile.strideCm) : ""),
    [weight, setWeight] = useState(profile ? String(profile.weightKg) : ""),
    [revision, setRevision] = useState(profile?.revision ?? 0);
  const value = {
      strideCm: Number(stride.trim().replace(",", ".")),
      weightKg: Number(weight.trim().replace(",", ".")),
    },
    valid = validActivityProfile(value),
    conflict = revision !== (profile?.revision ?? 0);
  return (
    <>
      <Card>
        <Info title={locale==="da-DK"?"Skridtlængde og vægt":"Stride length and weight"} icon="stride" palette={palette}><Text style={{color:colors.textMuted}}>{locale==="da-DK"?"Mål længden af 10 almindelige skridt, og del med 10. Indtast resultatet i cm. Din vægt bruges til at anslå energiforbruget.":"Measure 10 normal steps and divide by 10. Enter the result in cm. Your weight is used to estimate energy use."}</Text></Info>
        <Field
          label="Skridtlængde i cm"
          value={stride}
          onChangeText={setStride}
          keyboardType="numeric"
        />
        <Field
          label="Vægt i kg"
          value={weight}
          onChangeText={setWeight}
          keyboardType="numeric"
        />
        <Pill tone="info" icon="activity">
          Skridtlængde og vægt bruges til dine aktivitetsestimater
        </Pill>
        {!valid && (stride || weight) && (
          <Pill tone="attention">
            {translate(locale, "profile.validation")}
          </Pill>
        )}
        {conflict && (
          <StatePanel
            state="error"
            title={translate(locale, "settings.changedElsewhere")}
            actionLabel="Genindlæs"
            onAction={() => {
              setStride(profile ? String(profile.strideCm) : "");
              setWeight(profile ? String(profile.weightKg) : "");
              setRevision(profile?.revision ?? 0);
            }}
          />
        )}
        {state.profileError && (
          <StatePanel
            state="error"
            message={translate(locale, state.profileError)}
          />
        )}
      </Card>
      <Button
        label="Gem profil"
        icon="confirm"
        disabled={
          !valid ||
          conflict ||
          state.profileBusy ||
          !state.snapshot?.device?.capabilities?.activityProfile
        }
        onPress={() => session
          .saveActivityProfile(value.strideCm, value.weightKg, revision)
          .then((ok) => {
            if (ok) actions.goBack();
            return ok;
          })}
      />
      <Button label="Annullér" tone="quiet" onPress={actions.goBack} />
    </>
  );
}
